<template>
  <div>
    <dp-container v-if="loading">
      <dp-loading />
    </dp-container>
    <div v-else class="mx-auto d-flex flex-column" :class="{ 'd-none': loading }">
      <div
        v-for="htmlObj in htmlContent"
        :key="'marketing-content-' + htmlObj.sort"
        style="padding-top: 20px; row-gap: 1rem"
        :class="{ 'mt-3': hasNotifications }"
        :style="{ order: htmlObj.sort }"
        v-html="htmlObj.html"
      ></div>

      <div
        v-for="(item, index) in productInterrupt.marketingContentPetTrackingDevice"
        id="add-to-order"
        :key="`add-to-order-${index}`"
        :style="{ order: item.sort }"
      >
        <div class="exclusive-offer mb-5">
          <div class="bg-blue">
            <div class="container">
              <img
                  id="bottom-exclusive-device-img"
                  alt="Pet Tracker Device"
                  class="device-img"
                  :src="petTrackerDeviceImage"
              />
              <div class="column-left">
                <img
                    alt="Pet Tracker App"
                    :src="petTrackerAppImage"
                />
              </div>
              <div
                id="bottom-exclusive-container"
                class="container column-right"
                style="max-width: 550px !important; margin: auto; padding-top: 44px; padding-bottom: 44px;"
              >
                <div class="column-container w-100" style="margin: auto">
                  <h2 id="order-subtitle-bottom" v-html="subtitleBottom"></h2>
                  <p class="mb-4" v-html="callToActionBody"></p>
                  <p>
                    <DpPetTrackingDeviceAddToOrder
                      v-if="showAddToOrderComponent"
                      :api-token="userToken"
                      :api-url="apiUrl"
                      :initial-context="petTrackingDeviceAddToOrderContext"
                      @item-added-to-cart="addToCart"
                      @cart-has-no-devices="cartHasNoDevices"
                      @disable-action="continueButtonDisabled = $event"
                    />
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div class="container mt-4 pt-2 text-center d-block">
            <router-link
              to="Basket"
              class="btn cta"
              :class="{ 'cta-outline': !hasItemsInCart, disabled: continueButtonDisabled }"
              :event="continueButtonDisabled ? '' : 'click'"
            >
              {{ skipAndContinueButtonText }}
            </router-link>
          </div>
        </div>
      </div>

      <div ref="skipButton" class="container mt-4 pt-2 text-center" style="display: none;">
        <router-link
          to="Basket"
          class="btn cta"
          :class="{ 'cta-outline': !hasItemsInCart, disabled: continueButtonDisabled }"
          :event="continueButtonDisabled ? '' : 'click'"
        >
          {{ skipAndContinueButtonText }}
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { DpContainer, DpLoading, DpPetTrackingDeviceAddToOrder } from '@docupet/component-library';
import getImage from '@/mixins/getImage';

export default {
  name: 'ProductInterrupt',
  components: { DpContainer, DpLoading, DpPetTrackingDeviceAddToOrder },
  mixins: [getImage],
  metaTag() {
    return this.$router.currentRoute.meta;
  },
  data() {
    return {
      windowWidth: window.innerWidth,
      hasItemsInCart: false,
      continueButtonDisabled: false,
      hasErrors: false,
      buttonMoved: false,
    };
  },
  computed: {
    ...mapState({
      orderId: (state) => state.orderId,
      productInterrupt: (state) => state.marketing?.productInterrupt,
      hasNotifications: (state) => !!state.notification?.notifications?.filter((n) => n.showInLicensing)?.length,
      userToken: (state) => state.token,
      apiUrl: () => global.API_URL || process.env.VUE_APP_API_URL,
      petTrackingDeviceAddToOrderContext: (state) => state.marketing?.petTrackingDeviceAddToOrderContext,
      marketingPrice: (state) => state.marketing?.marketingPrice,
      loading(state) {
        return (
          state.marketing.loading ||
          state.user.loading ||
          state.user.cityLoading ||
          state.order.loading ||
          this.hasErrors ||
          !this.htmlContent ||
          !this.productInterrupt
        );
      },
      addToOrderSectionContext: (state) => state.marketing?.addToOrderSectionContext,
    }),
    htmlContent() {
      return this.productInterrupt?.marketingContentHtml;
    },
    variant() {
      return this.productInterrupt?.variant;
    },
    contentExperimentName() {
      return this.productInterrupt?.contentExperimentName;
    },
    showAddToOrderComponent() {
      return !this.loading && this.petTrackingDeviceAddToOrderContext && this.userToken && this.apiUrl;
    },
    petTrackerDeviceImage() {
      return this.addToOrderSectionContext.petTrackerDeviceImage;
    },
    petTrackerAppImage() {
      return this.addToOrderSectionContext.petTrackerAppImage;
    },
    subtitleBottom() {
      return this.addToOrderSectionContext.subtitleBottom;
    },
    callToActionBody() {
      return this.addToOrderSectionContext.callToActionBody;
    },
    skipAndContinueButtonText() {
      return this.hasItemsInCart
        ? this.addToOrderSectionContext.continueButtonText
        : this.addToOrderSectionContext.skipAndContinueButtonText;
    },
  },
  created() {
    if (!this.orderId) {
      this.$router.push({ name: 'Basket' });
    }
    this.$store
      .dispatch('marketing/determineProductInterrupt')
      .then((interruptData) => {
        if (!interruptData || !this.productInterrupt) {
          this.$router.push({ name: 'Basket' });
        }
        window?.dataLayer?.push({
          event: 'view_interrupt',
          type: this.contentExperimentName,
          variant_type: this.variant,
        });
      })
      .catch(() => {
        this.hasErrors = true;
      })
      .finally(() => {
        if (!this.productInterrupt || this.hasErrors) {
          this.$router.push({ name: 'Basket' });
        }

        if (this.petTrackingDeviceAddToOrderContext?.devicesCurrentlyInBasket.length > 0) {
          this.hasItemsInCart = true;
        }

        this.$nextTick(() => {
          this.initializeBootstrap();
        });
      });
  },
  updated() {
    if (!this.buttonMoved) {
      this.$nextTick(() => {
        let parent = this.$el.querySelector('#exclusive-offer');
        if (parent) {
          parent.append(this.$refs.skipButton);
          this.$refs.skipButton.style.display = 'inherit';
          this.buttonMoved = true;
        }
      });
    }
  },
  mounted() {
    window.addEventListener('resize', this.onWindowResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onWindowResize);
  },
  methods: {
    onWindowResize() {
      this.windowWidth = window.innerWidth;
    },
    addToCart() {
      this.hasItemsInCart = true;
    },
    cartHasNoDevices() {
      this.hasItemsInCart = false;
    },
    initializeBootstrap() {
      const tooltips = [].slice.call(document.querySelectorAll('[data-toggle="tooltip"]'));
      tooltips.forEach(function (tooltip) {
        new window.bootstrap.Tooltip(tooltip);
      });
    },
  },
};
</script>

<style lang="scss">
@import 'https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.6.0/css/all.min.css';

html {
  scroll-behavior: smooth;
}

@media (min-width: 992px) {
  .w-lg-75 {
    width: 75%;
  }

  #order-subtitle-bottom {
    font-size: 45px !important;
  }
}

@media (min-width: 768px) {
  #bottom-exclusive-container {
    padding-left: 3rem !important;
  }
}

@media (min-width: 900px) {
  #bottom-exclusive-container {
    padding-left: 4rem !important;
  }
}

.interrupt-container {
  max-width: 1200px;
}

.product-carousel-container {
  max-width: 1024px;
  display: contents;
  flex-direction: column;
  width: available;
  width: -moz-available;
  width: -webkit-fill-available;
}

// Product Styles
div:has(> .product-group-style-action-link) {
  margin-left: 25px;
  margin-right: 25px;
}

.product-group-style-action-link {
  padding-top: 4px;
  padding-bottom: 4px;
  margin-bottom: 16px;
  border-radius: 15px;
}

// Sticky Elements
.dp-container {
  overflow: visible !important;
}

div:has(.sticky-bottom) {
  position: sticky;
  position: -webkit-sticky;
  position: -moz-sticky;
  bottom: 0;
  z-index: 999;
}

.exclusive-offer {
  font-family: Lato;
  color: #4a4a4a;
  font-size: 16px;
  line-height: 130%;
  overflow-x: hidden;
}

.exclusive-offer img {
  width: 100%;
  height: auto;
}

.exclusive-offer .bg-blue {
  background: #f0f4ff;
}

.exclusive-offer .container {
  display: flex;
  flex-direction: row;
  position: relative;
  max-width: 1143px;
  padding: 0 24px;
}
.exclusive-offer .column-left {
  width: 42.5%;
  margin-right: 8.6%;
  align-self: end;
  padding-top: 44px;
  box-sizing: border-box;
}

.exclusive-offer .headline {
  font-size: 28px;
  font-weight: 700;
  line-height: 1.3;
  text-transform: uppercase;
  margin-bottom: 24px;
  color: #009fdf;
}

.exclusive-offer h2,
.exclusive-offer .price {
  font-size: 48px;
  font-weight: 700;
  line-height: 1.3;
  color: #003c71;
}

.exclusive-offer .price {
  font-size: 28px;
}

.exclusive-offer .cta,
.cta {
  padding: 24px 56px;
  box-sizing: border-box;
  background: #003c71;
  color: white;
  border-radius: 9px;
  font-size: 18px !important;
  font-weight: 700;
  line-height: 1.3;
  display: inline-block;
}

.exclusive-offer .cta:hover,
.cta:hover {
  text-decoration: none;
}

.exclusive-offer .column-right {
  width: 48.9%;
  padding-top: 66px;
}

.exclusive-offer .device-img {
  position: absolute;
  bottom: -2px;
  left: 42.5%;
  width: 36.4%;
  height: auto;
  margin-left: -23%;
}
.exclusive-offer .disclaimer {
  margin-top: 16px;
  font-size: 16px;
  font-weight: 400;
  line-height: 150%;
  color: #4a4a4a;
}

@media only screen and (max-width: 992px) {
  .exclusive-offer .headline {
    font-size: 20px;
    line-height: 1.5;
    margin-bottom: 16px;
  }

  .exclusive-offer h2,
  .exclusive-offer .price {
    font-size: 28px;
  }

  .exclusive-offer .price {
    font-size: 20px;
  }

  .exclusive-offer .cta,
  .cta {
    padding: 16px 40px;
    font-size: 16px !important;
  }

  .cta-outline {
    border: 2px solid #003c71 !important;
  }

  .pet-tracking-device-add-to-order-component {
    font-size: 16px !important;
  }
}
@media only screen and (max-width: 768px) {
  .exclusive-offer .column-left {
    width: 40%;
    margin-right: 15%;
  }

  .exclusive-offer .column-right {
    width: 57.7%;
    padding-top: 49px;
    padding-bottom: 20px;
  }

  .exclusive-offer .device-img {
    position: absolute;
    bottom: -2px;
    left: 31vw;
    width: 27.7vw;
    height: auto;
    margin-left: -13.5vw;
  }
}
@media only screen and (max-width: 576px) {
  .container {
    padding: 0 16px;
  }

  .exclusive-offer .container {
    display: block;
    padding-top: 50px;
    text-align: center;
  }

  .exclusive-offer .device-img {
    position: relative;
    bottom: unset;
    left: unset;
    width: 100%;
    margin: 0 auto 42px auto;
    max-width: 224px;
    height: auto;
  }

  .exclusive-offer .column-left {
    display: none;
  }

  .exclusive-offer .column-right {
    text-align: left;
    width: 100%;
    padding-bottom: 24px;
    padding-top: 0;
  }

  .exclusive-offer .price {
    margin-bottom: 42px;
  }

  .exclusive-offer .cta,
  .cta {
    width: 100%;
    text-align: center;
    display: block;
  }

  .exclusive-offer .headline,
  .exclusive-offer .price {
    font-size: 18px;
  }
}

.cta-outline {
  background: white !important;
  color: #003c71 !important;
  border-radius: 9px;
  border: #003c71 2px solid;
}

.cta {
  font-weight: 400 !important;
}
</style>
